module.exports = __webpack_public_path__ + "static/media/customer-attraction.6a8144b0.jpg";